import { DATE_STRING_FORMAT, formatDate } from '../../../utils/dates';
import { ActivityFeedDayGroup, GroupItemsByDayParams } from './activityFeedGrouping.types';

const getDayKey = (date: Date, timeZone?: string) => formatDate(date, DATE_STRING_FORMAT, timeZone);

export const groupItemsByDay = <Item>({
  items,
  getDate,
  timeZone,
}: GroupItemsByDayParams<Item>): ActivityFeedDayGroup<Item>[] => {
  const groups: ActivityFeedDayGroup<Item>[] = [];
  let currentKey: string | undefined;

  for (const item of items) {
    const dayKey = getDayKey(new Date(getDate(item)), timeZone);

    if (!dayKey) {
      continue;
    }

    const currentGroup = groups[groups.length - 1];

    if (currentGroup && dayKey === currentKey) {
      currentGroup.items.push(item);
      continue;
    }

    currentKey = dayKey;
    groups.push({ dayKey, items: [item] });
  }

  return groups;
};

export const getDayGroupCounts = <Item>(groups: ActivityFeedDayGroup<Item>[]): number[] =>
  groups.map((group) => group.items.length);
